

const levelThresholds = [0, 50, 120, 200, 300, 420, 560, 700, 850, 950];

const levelTitles = [
  "Wandering Newbie",
  "Curious Stroller",
  "Urban Walker",
  "Street Explorer",
  "Local Pathfinder",
  "City Trekker",
  "Attraction Hunter",
  "Urban Adventurer",
  "Hidden Gem Seeker",
  "Master Explorer"
];

function getUserLevel(points) {
  for (let i = levelThresholds.length - 1; i >= 0; i--) {
    if (points >= levelThresholds[i]) {
      return i + 1;
    }
  }
  return 1;
}

const UserLevelInfo = ({ points }) => {
  const userLevel = getUserLevel(points);
  const userTitle = levelTitles[userLevel - 1];

  return (
        <div className="global-description">
              Lv. {userLevel} - {userTitle}
            </div>
  );
};

export  {UserLevelInfo};
